export function buildBulkSelectionPayload(activeSearchRequest, pages) {
  if (!activeSearchRequest) {
    throw new Error("An active property search is required.");
  }

  // A page cursor from the visible results would be meaningless here: bulk
  // selection always walks the result set from its first row.
  const { search_after: _cursor, ...search } = activeSearchRequest;
  // /search-data takes list filters as comma-separated strings, the same as
  // ordinary searches; doObjToFormData would otherwise post `key[]` arrays.
  const normalized = Object.fromEntries(
    Object.entries(search).map(([key, value]) =>
      Array.isArray(value) ? [key, value.join(",")] : [key, value]
    )
  );

  return {
    ...normalized,
    page: 1,
    bulk_select_pages: pages,
  };
}

export async function requestBulkPropertyIds({
  activeSearch,
  pages,
  post,
  isCurrent,
}) {
  const response = await post(buildBulkSelectionPayload(activeSearch, pages));

  if (!isCurrent(activeSearch)) {
    return { propertyIds: [], stale: true };
  }

  if (!Array.isArray(response?.data?.propertyIds)) {
    throw new Error("Bulk property selection returned an invalid response.");
  }

  return {
    propertyIds: response.data.propertyIds,
    stale: false,
  };
}
